import { createAsyncThunk } from "@reduxjs/toolkit";
import { animateCss } from "../../../pages/TosterAlert";
import {
  allState,
  deleteOrganizationState,
  organizationState,
  organizationStateActive,
  organizationStateCreate,
  organizationZoneState,
} from "../../../api/organizationState_api";

export const organizationStateAction = createAsyncThunk(
  "organizationState/State",
  async (values, { rejectWithValue, getState }) => {
    try {
      const checklist = await organizationState();
      return checklist;
    } catch (error) {
      return rejectWithValue(error.message || "something went wrong");
    }
  }
);

export const organizationZoneStateAction = createAsyncThunk(
  "organizationState/ZoneState",
  async (values, { rejectWithValue, getState }) => {
    try {
      const checklist = await organizationZoneState();
      return checklist;
    } catch (error) {
      return rejectWithValue(error.message || "something went wrong");
    }
  }
);

export const allStateAction = createAsyncThunk(
  "organizationState/settings",
  async (values, { rejectWithValue, getState }) => {
    try {
      const checklist = await allState();
      return checklist;
    } catch (error) {
      return rejectWithValue(error.message || "something went wrong");
    }
  }
);

export const organizationStateCreateAction = createAsyncThunk(
  "organizationState/create",
  async (values, { rejectWithValue, getState }) => {
    try {
      const checklist = await organizationStateCreate(values);
      return checklist;
    } catch (error) {
      return rejectWithValue(error.message || "something went wrong");
    }
  }
);

export const organizationStateActiveAction = createAsyncThunk(
  "organizationState/Active",
  async (values, { rejectWithValue, getState }) => {
    try {
      const result = await organizationStateActive(values);
      return result;
    } catch (error) {
      return rejectWithValue(error.message || "something went wrong");
    }
  }
);

export const deleteOrganizationStateAction = createAsyncThunk(
  "organizationState/delete",
  async (values, { rejectWithValue, getState }) => {
    try {
      const result = await deleteOrganizationState(values);
      return result;
    } catch (error) {
      return rejectWithValue(error.message || "something went wrong");
    }
  }
);
